export default __webpack_public_path__ + "static/media/play.fed76f27.svg";